import { render } from "./EmailNewsletter.vue?vue&type=template&id=2fdeb340"
import script from "./EmailNewsletter.vue?vue&type=script&lang=js"
export * from "./EmailNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__